import api  from '@/services/api';
import swal from 'sweetalert';

export async function validarCreacionUsuario(idEmpresa, idSuscripcion) {
  try {
    const { data } = await api.get(`/usuarios/disponibles/${idEmpresa}/${idSuscripcion}`);
    return data > 0;
  } catch (error) {
    console.error('Error al validar usuarios disponibles:', error);
    swal('Error!', 'Problema al obtener la cantidad de usuarios.', 'error');
    return false;
  }
}